import { useEffect } from 'react';
import { useCookieConsent } from './CookieConsentContext';
import { loadGoogleAnalytics, loadGoogleAdSense, loadFirebaseAnalytics } from './ScriptLoader';

const GA_ID = process.env.REACT_APP_GA_ID;
const ADSENSE_ID = process.env.REACT_APP_ADSENSE_ID;

export default function ConsentScriptManager() {
	const { consent, consentGiven } = useCookieConsent();

	useEffect(() => {
		if (!consentGiven) return;

		if (consent.analytics) {
			loadGoogleAnalytics(GA_ID).catch(() => {});
			loadFirebaseAnalytics().catch(() => {});
		}
	}, [consent.analytics, consentGiven]);

	useEffect(() => {
		if (!consentGiven) return;

		if (consent.marketing) {
			loadGoogleAdSense(ADSENSE_ID).catch(() => {});
		}
	}, [consent.marketing, consentGiven]);

	return null;
}
